import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-lsa-dark text-white py-14 px-5 text-center" data-id="element-71">
      <div className="max-w-xl mx-auto" data-id="element-72">
        <h2 className="text-[28px] sm:text-[32px] font-bold mb-8 leading-tight" data-id="element-73">
          La próxima clase que des, va a ser la mejor que diste.{' '}
          <span className="text-3xl align-middle ml-1" data-id="element-74">🤟</span>
        </h2>

        <div className="flex flex-col gap-3 mb-8" data-id="element-75">
          <button onClick={scrollToPricing} className="w-full bg-lsa-cyan hover:brightness-110 text-lsa-deep h-[64px] rounded-xl font-bold text-[18px] transition-all shadow-lg shadow-lsa-cyan/30 flex items-center justify-center gap-2" data-id="element-76">
            <span className="text-xl" data-id="element-77">🤟</span> Quiero el Sistema para
            Profesores
          </button>

          <button onClick={scrollToPricing} className="w-full bg-transparent border-2 border-white/30 hover:border-white text-white h-[64px] rounded-xl font-bold text-[18px] transition-colors flex items-center justify-center gap-2" data-id="element-78">
            <span className="text-xl" data-id="element-79">🚀</span> Quiero el Plan Profesional
          </button>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[13px] text-white/70 font-medium" data-id="element-80">
          <span className="flex items-center gap-1.5" data-id="element-81">
            <ShieldCheck size={16} className="text-lsa-celeste" data-id="element-82" /> Garantía 7
            días
          </span>
          <span className="hidden sm:inline" data-id="element-83">·</span>
          <span className="flex items-center gap-1.5" data-id="element-84">
            <Lock size={16} className="text-lsa-celeste" data-id="element-85" /> Pago seguro
          </span>
          <span className="hidden sm:inline" data-id="element-86">·</span>
          <span className="flex items-center gap-1.5" data-id="element-87">
            <Zap size={16} className="text-lsa-celeste" data-id="element-88" /> Acceso inmediato
          </span>
        </div>
      </div>
    </section>;
}